import { AxiosError, AxiosRequestConfig } from 'axios'
import qs from 'qs'
import { infintyDeserializeReplacer } from '../helpers'

export const axiosConfig: AxiosRequestConfig = {
  withCredentials: true,
  xsrfCookieName: undefined,
  paramsSerializer: (params) =>
    qs.stringify(params, {
      filter: (_prefix, value) => (value === null ? 'null' : value),
      arrayFormat: 'brackets'
    }),
  transformResponse: [
    function (data) {
      const transitional = this.transitional
      const forcedJSONParsing = transitional && transitional.forcedJSONParsing
      const JSONRequested = this.responseType === 'json'
      const hasStringData = data && typeof data === 'string'
      if (hasStringData && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
        const silentJSONParsing = transitional && transitional.silentJSONParsing
        const strictJSONParsing = !silentJSONParsing && JSONRequested
        try {
          return JSON.parse(data, infintyDeserializeReplacer)
        } catch (e) {
          if (strictJSONParsing) {
            if (e.name === 'SyntaxError') {
              throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null)
            }
            throw e
          }
        }
      }
      return data
    }
  ]
}
